// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reset-password-wrapper[data-v-e1f7bc7e]{display:flex;flex:1}.reset-password-wrapper[data-v-e1f7bc7e] .auth-reset-password__password:last-child .exc-input-label-error-wrapper__content{margin:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
